import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../hooks';
import { prettyPrintType } from '../types/CommonType';
import { prettyPrintValue } from '../types/CommonValue';
import { selectEntitiesForDevice, subscribeEntities } from '../reducers/entitiesSlice';
export const ConfigDevice = () => {
    const { id } = useParams();
    const deviceMap = useAppSelector(state => state.definitions.devices);
    const actions = useAppSelector(state => state.definitions.actions);
    const entityStates = useAppSelector(state => state.entity_states);
    const dispatch = useAppDispatch();
    const device_id = Number(id);
    const device = deviceMap[device_id];
    const deviceEntities = useAppSelector(state => selectEntitiesForDevice(state, device_id));
    ;
    const deviceActions = [];
    useEffect(() => subscribeEntities(dispatch, deviceEntities), [deviceEntities]);
    if (!device) {
        return null;
    }
    const entityRows = [];
    for (const e of deviceEntities) {
        const v = entityStates[e.id];
        const value = v == undefined ? '' : prettyPrintValue(v.value);
        const time = v == undefined ? '' : new Date(v.ts).toLocaleString();
        entityRows.push(_jsxs("tr", { children: [_jsx("td", { children: e.title }), _jsx("td", { children: prettyPrintType(e.type) }), _jsx("td", { children: value }), _jsx("td", { children: time })] }, e.id));
    }
    for (const a of Object.values(actions)) {
        if (a.device_id == device_id) {
            deviceActions.push(a);
        }
    }
    const actionRows = [];
    for (const a of deviceActions) {
        actionRows.push(_jsxs("tr", { children: [_jsx("td", { children: a.title }), _jsx("td", { children: prettyPrintType(a.type) })] }, a.id));
    }
    return (_jsxs("div", { className: "page-container", children: [_jsxs("h2", { children: ["Device ", device.title] }), _jsx("h3", { children: "Entities" }), _jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { style: { textAlign: 'left' }, children: "Title" }), _jsx("th", { style: { textAlign: 'left' }, children: "Type" }), _jsx("th", { style: { textAlign: 'left' }, children: "Value" }), _jsx("th", { style: { textAlign: 'left' }, children: "Time" })] }) }), _jsx("tbody", { children: entityRows })] }), _jsx("h3", { children: "Actions" }), _jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { style: { textAlign: 'left' }, children: "Title" }), _jsx("th", { style: { textAlign: 'left' }, children: "Type" })] }) }), _jsx("tbody", { children: actionRows })] })] }));
};
